import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconClose, IconBack } from "./icons";
import { Switch, SelectServices } from "@lib/components";
import { MenuItem, QuickSettingsContainer, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorDescription, MenuColorBodyWrapper, MenuColorFormGroup, MenuColorLabel, MenuColorFooterWrapper, MenuToggleContainer, MenuToggleText, MenuLineSeparator, MenuPublishPlatformContainer, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, ButtonV2 } from "./layout.c";
import { ListServicesOptionsNoB } from '@lib/common';
import { toJS } from 'mobx';

export interface MenuVisibilityConditions {
    pos?: { enabled: boolean; services: string[] };
    online?: { enabled: boolean; services: string[] };
    external_platforms?: { uber?: { enabled: boolean }; abacus?: { enabled: boolean } };
}

interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave?: (conditions: MenuVisibilityConditions) => void;
    title?: string;
    initialConditions?: MenuVisibilityConditions;
}

interface State extends MenuVisibilityConditions {}

@inject("store") @observer
class MenuVisibilityClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        const c = props.initialConditions;
        this.state = {
            pos: c?.pos ?? { enabled: false, services: [] },
            online: c?.online ?? { enabled: false, services: [] },
            external_platforms: c?.external_platforms ?? { uber: { enabled: false }, abacus: { enabled: false } }
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.initialConditions !== prevProps.initialConditions) {
            const c = this.props.initialConditions;
            console.log('triggered conditions update', toJS(c));
            this.setState({
                pos: c?.pos ?? { enabled: false, services: [] },
                online: c?.online ?? { enabled: false, services: [] },
                external_platforms: c?.external_platforms ?? { uber: { enabled: false }, abacus: { enabled: false } }
            });
        }
    }


    render() {
        const { show, onHide, onSave, title } = this.props;
        const { pos, online, external_platforms } = this.state;
  
        return (
            <QuickSettingsContainer className={show ? 'active' : ''}>
                <MenuColorHeaderWrapper>
                    <MenuItem onClick={onHide}><IconBack /></MenuItem>
                    <MenuColorHeaderTitleWrapper>
                        {title || ''} {title ? '- ' : ''} Visibility
                    </MenuColorHeaderTitleWrapper>
                    <MenuItem onClick={onHide}><IconClose /></MenuItem>
                </MenuColorHeaderWrapper>
                <MenuColorBodyWrapper style={{ minHeight: '50vh', overflowY: 'scroll' }}>
                    <MenuColorDescription>This item will be active on</MenuColorDescription>
                    <MenuColorFormGroup>
                        <MenuColorLabel>POS</MenuColorLabel>
                        <MenuToggleContainer>
                            <MenuToggleText>{pos?.enabled ? 'On' : 'Off'}</MenuToggleText>
                            <Switch
                                id="pos-active"
                                checked={!!pos?.enabled}
                                onChange={(e) => this.setState({ pos: { ...pos!, enabled: e.target.checked, services: pos?.services ?? [] } })}
                            />
                        </MenuToggleContainer>
                    </MenuColorFormGroup>
                    <MenuColorLabel>Select Service Type</MenuColorLabel>
                    <SelectServices
                        type="multi"
                        value={pos?.services ?? []}
                        onChange={(options: string[]) => this.setState({ pos: { ...pos!, services: options } })}
                        options={ListServicesOptionsNoB}
                    />
                    <MenuLineSeparator />
                    <MenuColorFormGroup>
                        <MenuColorLabel>Online</MenuColorLabel>
                        <MenuToggleContainer>
                            <MenuToggleText>{online?.enabled ? 'On' : 'Off'}</MenuToggleText>
                            <Switch
                                id="online-active"
                                checked={!!online?.enabled}
                                onChange={(e) => this.setState({ online: { ...online!, enabled: e.target.checked, services: online?.services ?? [] } })}
                            />
                        </MenuToggleContainer>
                    </MenuColorFormGroup>
                    <MenuColorLabel>Select Service Type</MenuColorLabel>
                    <SelectServices
                        type="multi"
                        value={online?.services ?? []}
                        onChange={(options: string[]) => this.setState({ online: { ...online!, services: options } })}
                        options={ListServicesOptionsNoB}
                    />
                    <MenuLineSeparator />
                    <MenuColorLabel>Publish on other platforms</MenuColorLabel>
                    <MenuPublishPlatformContainer className='quick-sidebar' style={{width: '100%'}}>
                        <MenuPublishPlatFormItem>
                            <MenuPublishPlatFormItemHeader>
                                <MenuPublishPlatFormItemHeaderLabel>Uber</MenuPublishPlatFormItemHeaderLabel>
                                <MenuToggleContainer>
                                    <MenuToggleText>{external_platforms?.uber?.enabled ? 'On' : 'Off'}</MenuToggleText>
                                    <Switch
                                        id="uber-enabled"
                                        checked={!!external_platforms?.uber?.enabled}
                                        onChange={(e) => this.setState({
                                            external_platforms: {
                                                ...external_platforms,
                                                uber: { enabled: e.target.checked }
                                            }
                                        })}
                                    />
                                </MenuToggleContainer>
                            </MenuPublishPlatFormItemHeader>
                        </MenuPublishPlatFormItem>
                        <MenuPublishPlatFormItem>
                            <MenuPublishPlatFormItemHeader>
                                <MenuPublishPlatFormItemHeaderLabel>Abacus</MenuPublishPlatFormItemHeaderLabel>
                                <MenuToggleContainer>
                                    <MenuToggleText>{external_platforms?.abacus?.enabled ? 'On' : 'Off'}</MenuToggleText>
                                    <Switch
                                        id="abacus-enabled"
                                        checked={!!external_platforms?.abacus?.enabled}
                                        onChange={(e) => this.setState({
                                            external_platforms: {
                                                ...external_platforms,
                                                abacus: { enabled: e.target.checked }
                                            }
                                        })}
                                    />
                                </MenuToggleContainer>
                            </MenuPublishPlatFormItemHeader>
                        </MenuPublishPlatFormItem>
                    </MenuPublishPlatformContainer>
                </MenuColorBodyWrapper>
                <MenuColorFooterWrapper>
                    <ButtonV2 variant="default" onClick={onHide}>Cancel</ButtonV2>
                    <ButtonV2 onClick={() => onSave?.(this.state)}>Save</ButtonV2>
                </MenuColorFooterWrapper>
            </QuickSettingsContainer>
        );
    }
}
export const MenuVisibility = withTranslation()(MenuVisibilityClass);
